<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark shadow-sm sticky-top py-3">
    <div class="container-fluid">

      <!-- Logo + Brand -->
      <a class="navbar-brand d-flex align-items-center" href="#">
        
        <span class="fw-bold fs-4 d-flex align-items-center text-white">
          <i class="bi bi-laptop me-2"></i>
           Compuservicio
        </span>
      </a>

      <!-- Hamburger -->
      <button
        class="navbar-toggler custom-toggler"
        type="button"
        @click="toggleNav"
        :aria-expanded="isOpen.toString()"
        aria-label="Toggle navigation"
      >
        <span :class="['bar', { open: isOpen }]" />
        <span :class="['bar', { open: isOpen }]" />
        <span :class="['bar', { open: isOpen }]" />
      </button>

      <!-- Menu Items -->
      <div :class="['collapse navbar-collapse', { show: isOpen }]" id="navbarContent">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center">

          <li class="nav-item" v-for="item in items" :key="item.id">
            <a
              class="nav-link d-flex align-items-center"
              :href="item.href"
              @click="closeOnNavigate"
            >
              <i :class="item.icon + ' me-2'"></i>
              {{ item.label }}
            </a>
          </li>

          <!-- Botón WhatsApp -->
          <li class="nav-item ms-lg-3 mt-2 mt-lg-0">
            <a
              class="btn btn-whatsapp btn-sm d-flex align-items-center"
              href="https://wa.me/584123659519"
              target="_blank"
            >
              <i class="bi bi-whatsapp me-2"></i>
              WhatsApp
            </a>
          </li>

        </ul>
      </div>

    </div>
  </nav>
</template>

<script>
export default {
  name: "AppNavbar",
  data() {
    return {
      isOpen: false,
      items: [
        { id: 'inicio', label: 'Inicio', href: '#inicio', icon: 'bi bi-house-door-fill' },
        { id: 'servicios', label: 'Servicios', href: '#servicios', icon: 'bi bi-tools' },
        { id: 'sobre', label: 'Sobre Nosotros', href: '#sobre-nosotros', icon: 'bi bi-info-circle-fill' },
        { id: 'contacto', label: 'Contacto', href: '#contacto', icon: 'bi bi-telephone-fill' }
      ]
    }
  },
  methods: {
    toggleNav() {
      this.isOpen = !this.isOpen;
    },
    closeOnNavigate() {
      if (this.isOpen) this.isOpen = false;
    }
  }
};
</script>

<style scoped>
/* LOGO GRANDE Y GLOW */
.logo-lg {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  box-shadow: 0 0 15px rgba(13, 110, 253, 0.9);
  animation: glow 2.5s infinite ease-in-out;
}
@keyframes glow {
  0%, 100% { box-shadow: 0 0 15px rgba(13,110,253,0.9); }
  50% { box-shadow: 0 0 25px rgba(13,110,253,1); }
}

/* BOTÓN WHATSAPP */
.btn-whatsapp {
  background: #25D366;
  color: white;
  font-weight: 600;
  border-radius: 10px;
  transition: 0.3s;
  box-shadow: 0 0 8px rgba(37, 211, 102, 0.7);
}
.btn-whatsapp:hover {
  background: #1ebe5d;
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 0 15px rgba(37, 211, 102, 1);
}

/* HAMBURGUESA RESPONSIVE */
.custom-toggler {
  width: 48px;
  height: 48px;
  border: none;
  background: transparent;
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.custom-toggler .bar {
  width: 28px;
  height: 3px;
  background: #0d6efd;
  border-radius: 3px;
  transition: 0.35s;
}
.custom-toggler .bar.open:nth-child(1) {
  transform: translateY(8px) rotate(45deg);
}
.custom-toggler .bar.open:nth-child(2) {
  opacity: 0;
}
.custom-toggler .bar.open:nth-child(3) {
  transform: translateY(-8px) rotate(-45deg);
}

@media (max-width: 991.98px) {
  .custom-toggler {
    display: flex;
  }
}

/* LINKS */
.nav-link {
  transition: 200ms;
  font-weight: 600;
  color: white;
}
.nav-link:hover {
  color: #0d6efd;
  transform: translateY(-3px);
}
.nav-link i {
  font-size: 1.25rem;
  transition: 0.25s;
}
.nav-link:hover i {
  transform: scale(1.2);
}

/* MENU MOBILE */
@media (max-width: 991.98px) {
  .collapse.navbar-collapse {
    background: rgba(19,22,30,0.98);
    padding: 20px;
    position: fixed;
    top: 80px;
    right: 0;
    left: 0;
    z-index: 9999;
    animation: slideDown 0.28s ease-out;
    border-top: 1px solid rgba(255,255,255,0.1);
  }
}
@keyframes slideDown {
  from { opacity: 0; transform: translateY(-15px); }
  to { opacity: 1; transform: translateY(0); }
}

/* RESPONSIVE LOGO EN MÓVIL */
@media (max-width: 575.98px) {
  .logo-lg {
    width: 50px;
    height: 50px;
  }
  .navbar-brand span {
    font-size: 1rem;
  }
  .btn-whatsapp {
    font-size: 0.85rem;
    padding: 6px 12px;
  }
}
</style>
